import { useCallback } from 'react';
import { createFileRoute, useNavigate } from '@tanstack/react-router';

import { PlayerProfilePageWidget } from '@features/user/pages/PlayerProfilePage/PlayerProfilePageWidget';

export const Route = createFileRoute('/profile/')({
  component: () => <Page />,
});

function Page() {
  const navigate = useNavigate();
  const setIsClubsAndTournamentsOpen = useCallback(
    (isOpen: boolean) => {
      if (isOpen) {
        navigate({
          to: '/profile/clubs-and-tournaments',
          from: '/',
        });
      }
    },
    [navigate],
  );

  const setIsEloStatsModalOpen = useCallback(
    (isOpen: boolean) => {
      if (isOpen) {
        navigate({
          to: '/profile/stats',
          from: '/',
        });
      }
    },
    [navigate],
  );

  return (
    <PlayerProfilePageWidget
      isEloStatsModalOpen={false}
      isClubsAndTournamentsOpen={false}
      setIsEloStatsModalOpen={setIsEloStatsModalOpen}
      setIsClubsAndTournamentsOpen={setIsClubsAndTournamentsOpen}
    />
  );
}
